import isTruthy from "@/lib/utils/boolean/isTruthy";
import getMostCommonDayOfWeekForRuns from "@/lib/utils/date/getMostCommonDayOfWeekForRuns";
import { SeasonWithMaybeCourt, SeasonWithMaybeCrew, SeasonWithRuns } from "@shared/lib/database/query.types";
import { format, isSameDay, parseISO, setDay } from "date-fns";
import { computed } from "vue";

export default function (season: { readonly value: (SeasonWithMaybeCourt & SeasonWithMaybeCrew & SeasonWithRuns) | null }) {
  const timezone = computed(() => season.value?.court?.timezone || "America/New_York");

  const startDate = computed(() => {
    if (!season.value?.start_on) return;

    return parseISO(season.value.start_on);
  });

  const endDate = computed(() => {
    if (!season.value?.end_on) return;

    return parseISO(season.value.end_on);
  });

  const dateRange = computed(() => {
    if (!startDate.value || !endDate.value) return [];

    if (isSameDay(startDate.value, endDate.value)) return [startDate.value];

    return [startDate.value, endDate.value];
  });

  const formattedDateRange = computed(() => {
    return dateRange.value
      .map((date) => format(date, "MMM d"))
      .join(" – ");
  });

  const formattedTimeOfDay = computed(() => {
    if (!season.value?.default_start_time) return null;

    const hours = parseInt(season.value.default_start_time.split(":")[0]);
    if (hours >= 4 && hours < 12) return "mornings";
    if (hours < 4 || hours >= 17) return "nights";

    return null;
  });

  const formattedSeasonName = computed(() => {
    if (!startDate.value) return;

    const mostCommonDayOfWeek = getMostCommonDayOfWeekForRuns(season.value?.runs || [], timezone.value);
    if (mostCommonDayOfWeek === null) return;

    const dayOfWeek = format(setDay(startDate.value, mostCommonDayOfWeek), "EEEE");

    return [dayOfWeek, formattedTimeOfDay.value].filter(isTruthy).join(" ");
  });

  return {
    formattedDateRange,
    formattedTimeOfDay,
    formattedSeasonName,
  };
}
